import { render } from "./fb5.vue?vue&type=template&id=146d903a&scoped=true"
import script from "./fb5.vue?vue&type=script&lang=js"
export * from "./fb5.vue?vue&type=script&lang=js"

import "./fb5.vue?vue&type=style&index=0&id=146d903a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146d903a"]])

export default __exports__